<template>
  <div style="width: 100%; height: 100%">
    <home1 v-if="showHome1 == 1" @toggleComponent="flag => (showHome1 = flag)"></home1>
    <home2 v-if="showHome1 == 2" @toggleComponent="flag => (showHome1 = flag)"></home2>
    <home3 v-if="showHome1 == 3" @toggleComponent="flag => (showHome1 = flag)"></home3>
    <home4 v-if="showHome1 == 4" @toggleComponent="flag => (showHome1 = flag)"></home4>
    <home5 v-if="showHome1 == 5" @toggleComponent="flag => (showHome1 = flag)"></home5>
    <home6 v-if="showHome1 == 6" @toggleComponent="flag => (showHome1 = flag)"></home6>
    <home7 v-if="showHome1 == 7" @toggleComponent="flag => (showHome1 = flag)"></home7>
    <home8 v-if="showHome1 == 8" @toggleComponent="flag => (showHome1 = flag)"></home8>
  </div>
</template>
<script>
import home1 from './components/homeTemplate/home1.vue';
import home2 from './components/homeTemplate/home2.vue';
import home3 from './components/homeTemplate/home3.vue';
import home4 from './components/homeTemplate/home4.vue';
import home5 from './components/homeTemplate/home5.vue';
import home6 from './components/homeTemplate/home6.vue';
import home7 from './components/homeTemplate/home7.vue';
import home8 from './components/homeTemplate/home8.vue';

export default {
  components: {
    home1,
    home2,
    home3,
    home4,
    home5,
    home6,
    home7,
    home8
  },
  data() {
    return {
      showHome1: 1,
    };
  },
};
</script>
